import React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

// The stores of one agent (see botsOf): a stock integration's inventory applies to all of them.
export default function StoreChips({ stores }) {
  return (
    <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
      {stores.map((name, index) => (
        <Chip key={`${name}-${index}`} size="small" label={name} />
      ))}
    </Stack>
  );
}
